// Mirrored in frontend/constants/utils/chat_work_access.js. These are setup
// requirements, never permission grants. Launch still validates signed access.
const { getWorkCapabilityGap } = require('./chat_work_capabilities');
function currentWorkRequest(prompt) {
    const text = String(prompt || '');
    const marker = '\n\nCurrent user request:\n';
    return text.includes(marker) ? text.slice(text.lastIndexOf(marker) + marker.length) : text;
}
function getWorkAccessRequirement(prompt) {
    const request = currentWorkRequest(prompt);
    const gap = getWorkCapabilityGap(request);
    const text = request.replace(/(?:https?:\/\/|www\.)[^\s]+/gi, '<link>')
        .replace(/```[\s\S]*?```|`[^`]*`|"[^"\n]*"|“[^”\n]*”/g, ' ');
    if (!gap) return null;
    if (/\b(?:local|connected)\s+(?:project\s+)?(?:folder|directory|files?|repo(?:sitory)?|codebase)\b|\b(?:folder|files?|repo(?:sitory)?)\b.{0,25}\bon (?:my|this) (?:computer|mac|desktop)\b/i.test(text)) return 'local-files';
    if (gap === 'browser' && /\b(?:my|current|open|existing)\s+(?:browser|tabs?)\b|\b(?:brave|chrome|safari|edge)\b/i.test(text)) return 'local-browser';
    if (gap === 'deployment') return 'hosting';
    if (gap === 'browser' && /\b(?:private|signed.in|logged.in|my account|dashboard)\b/i.test(text)) return 'browser-login';
    return null;
}
function getWorkAccessStatus(requirement, environment = {}) {
    const { platform, distribution, localProject, localBrowser, remoteProject } = environment;
    const directMac = platform === 'macos' && distribution === 'direct';
    if (requirement === 'local-files') {
        if (localProject === true && directMac || remoteProject === true && ['ios', 'android'].includes(platform)) return { canLaunch: true, notice: 'folderVerified' };
        return { canLaunch: false, notice: directMac ? 'selectFolder' : platform === 'macos' ? 'cloudFiles' : 'connectMacFolder' };
    }
    if (requirement === 'local-browser') {
        if (directMac && localBrowser === true) return { canLaunch: true, notice: 'browserVerified' };
        return { canLaunch: false, notice: directMac ? 'connectBrowser' : 'useMacBrowser' };
    }
    if (requirement === 'hosting') return { canLaunch: true, notice: 'hostingAccess' };
    if (requirement === 'browser-login') return { canLaunch: true, notice: 'browserLogin' };
    return { canLaunch: true, notice: null };
}
module.exports = { currentWorkRequest, getWorkAccessRequirement, getWorkAccessStatus };
